import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=238f4654&scoped=true&"
import script from "./UserAvatar.vue?vue&type=script&lang=ts&"
export * from "./UserAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=238f4654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f4654",
  null
  
)

export default component.exports